// Widget Scripts
import cardWidget from './js/widgets/cardWidget.js';
import contact from './js/widgets/contact.js';
import directions from './js/widgets/directions.js';
// import eventFeed from './js/widgets/eventFeed.js';
import eventFeedAuto from './js/widgets/eventFeedAuto.js';
import headerButton from './js/widgets/headerButton.js';
import mainFeature from './js/widgets/mainFeature.js';
import seoWidget from './js/widgets/seoWidget.js';
import splashPage from './js/splashPage.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function(){
    splashPage();
    cardWidget();
    directions();
    eventFeedAuto();
    mainFeature();
    seoWidget();
  });
}

// Initialize Sitewide Widgets
$(document).ready(function() {
  contact();
  headerButton();
});